import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Container } from '@amzn/dvui/dist/Container'
import { Text } from '@amzn/dvui/dist/Text'
import * as st from './contactUs.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { ContactUsBox } from './contactUsBox'


export interface IContactUsProps {
  content?: WpsRuntime.atv.wps.ContactUsModelProps
}

export const ContactUsComp = ({ content }: IContactUsProps) =>
  content && content.contactUsBoxList && content.contactUsBoxList.length ? (
    <Container className={`${stUtility.pageSection} ${st.contactUs}`}>
      <span data-automation-id="av-contact-us">
        <div id="contactus" className={st.contactUsHeader}>
          <h1><Text string={content.header}/></h1>
        </div>
        <div className={st.contactUsBody}>
          {content.contactUsBoxList.map((box, idx) =>
            <ContactUsBox {...box} key={idx}/>)}
        </div>
      </span>
    </Container>) : null


export const ContactUs = ContactUsComp
